<template>
  <v-list-item class="mb-0 justify-space-between pl-3">
    <v-list-item-avatar>
      <v-img src="https://randomuser.me/api/portraits/men/85.jpg"></v-img>
    </v-list-item-avatar>
    <v-list-item-content class="pl-2">
      <v-list-item-title class="text-h4">
        <strong class="mr-1 font-weight-black">Vue Test</strong>
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: "DrawerHeader",
};
</script>
